import React, { Component, useEffect } from 'react';
import { Link } from "react-router-dom";
import '../view/css/NavBar.css';
import { LoginModal } from '../controller/LoginModal';
import Notification from '../controller/notification_component/Notification';
import Badge from '@material-ui/core/Badge';
import {CreateEvent} from '../model/event_model/CreateEvent';
import {ContactUsModal} from '../controller/ContactUsModal';
import Delayed from './Delayed';
import * as firebase from 'firebase';
import userEvent from '@testing-library/user-event';



export const NavBarGuest = () => {
    return (
        <header height="80" className="navheader">
            <div className="navheaderContent">
                <div className="LogoBannerBox">
                    <a aria-current="page" className="homebtn" href="/">
                        <img src={process.env.PUBLIC_URL + '/digitalassets/logoNoBg.png'} className="homebtnlogo" alt="logo" />
                        <span>Breeze</span>
                    </a>
                </div>
                <Delayed waitBeforeShow={180}>
                <nav className="nav">
                    <div className="navList">
                        <ContactUsModal className="LoginModalCSS" />
                        <LoginModal className="LoginModalCSS" />
                    </div>
                </nav>
                </Delayed>
            </div>
        </header>
    );
}


const listItems = [
    {
        UTC: "1408648665",
        list: [
            {
                type: "Warning",
                content: "Everyone is lost",
                count: 1,
                timestamp: "1PM"
            }
        ]
    },
    {
        UTC: "1408648665",
        list: [
            {
                type: "Warning",
                content: "Everyone is lost",
                count: 1,
                timestamp: "1PM"
            }
        ]
    },
    {
        UTC: "1598103780",
        list: [
            {
                type: "Message",
                content: "Come join me Ed",
                count: 1
            }
        ]
    },
    {
        UTC: "1595594400",
        list: [
            {
                type: "SOS",
                content: "I'm lost in the sauce",
                count: 1
            }
        ]
    },
    {
        UTC: "1595575200",
        list: [
            {
                type: "Critical",
                content: "I Broke a lot of things",
                count: 1
            }
        ]
    }
];


export const NavBarUser = () => {
    const [notification, setNotif] = React.useState([]);

    const getNotifs = async () => {
        var user = firebase.auth().currentUser;
        var firestore = firebase.firestore();

        if (user) {
            var notifs = [];
            var stop_rend = false;
            const docRef = firestore.collection("Users").doc(user.email);
            let doc = await docRef.get();
            if (doc.exists && !stop_rend){
                const notifications = doc.data().notification;
                let allPromises = await notifications.map(async (notif) => {
                    let res = await notif.get();
                    
                    if (res.exists){
                        const doccer = res.data();
                        notifs.push({
                            'title': doccer.event_title,
                            'location': doccer.location,
                            'start': doccer.event_start.toDate(),
                            'end': doccer.event_end.toDate(),
                            'affiliate': doccer.username,
                        })
                    }
                    
                })
                await Promise.all(allPromises);
                stop_rend = true;
                setNotif(notifs);
                return true;
            }
        }
        return false;
    }
    
    useEffect(() => {
        // getList();
        getNotifs();
    },[])

    return (
        <header height="80" className="navheader">
            <div className="navheaderContent">
                <div className="LogoBannerBox">
                    <Link className="homebtn" to="/Profile">
                        <img src={process.env.PUBLIC_URL + '/digitalassets/logoNoBg.png'} className="homebtnlogo" alt="logo" />
                        <span>Breeze</span>
                    </Link>
                </div>
                <Delayed waitBeforeShow={180}>
                <nav className="nav">
                    <div className="navList">
                        <Link className="iconanchor" to="/Explore">
                            <img alt="searchbutton" className="navIcons" src={process.env.PUBLIC_URL + '/digitalassets/search.png'} />
                        </Link>
                        <Link className="iconanchor" to="/Calendar">
                            <img alt="calendarbutton" className="navIcons" src={process.env.PUBLIC_URL + '/digitalassets/calendar.png'} />
                        </Link>
                        <a className="iconanchor">
                          
                            {/* <Badge badgeContent={10} color="secondary" max={9}> */}
                            {console.log("Notifications passed in: " + notification)}
                     
                            <Notification noFetchData={getNotifs} listItems={notification}/>
                            {/* </Badge> */}
                        </a>
                        <Link className="iconanchor" to="/ProfileSettings">
                            <img alt="profilebutton" className="navIcons" src={process.env.PUBLIC_URL + '/digitalassets/profile.png'} />
                        </Link>
                    </div>
                </nav>
                </Delayed>
            </div>
        </header>
    );
}


export const NavBarAffiliate = () => {
    return (
        <header height="80" className="navheader">
            <div className="navheaderContent">
                <div className="LogoBannerBox">
                    <Link className="homebtn" to="/Profile">
                        <img src={process.env.PUBLIC_URL + '/digitalassets/logoNoBg.png'} className="homebtnlogo" alt="logo" />
                        <span>Breeze</span>
                    </Link>
                </div>
                <Delayed waitBeforeShow={180}>
                <nav className="nav">
                    <div className="navList">
                        <Link className="iconanchor" to="/Explore">
                            <img alt="searchbutton" className="navIcons" src={process.env.PUBLIC_URL + '/digitalassets/search.png'} />
                        </Link>
                        <a className="iconanchor">
                            <CreateEvent/>
                        </a>
                        <Link className="iconanchor" to="/Calendar">
                            <img alt="calendarbutton" className="navIcons" src={process.env.PUBLIC_URL + '/digitalassets/calendar.png'} />
                        </Link>
                        <Link className="iconanchor" to="/ProfileSettings">
                            <img alt="profilebutton" className="navIcons" src={process.env.PUBLIC_URL + '/digitalassets/profile.png'} />
                        </Link>
                    </div>
                </nav>
                </Delayed>
            </div>
        </header>
    );
}
